// Mise en forme des messages des actions de masse sur la liste des contrats (DPAE, signature…).
//
// Les messages passent par SectionAlert, qui rend `Dialog.label` en v-html et centre tout son
// contenu : la mise en forme est donc portée par le texte lui-même, en styles en ligne — aucune
// classe de titre de dialogue n'existe dans les feuilles du projet.

/**
 * Titre de modale. SectionAlert n'affiche pas `Dialog.title` — seul `label` est rendu — le titre
 * fait donc partie du message.
 */
export function titreModale(titre: string): string {
  return '<div style="font-size:17px;font-weight:600;color:#135253;padding-bottom:14px">'
    + `${titre}</div>`;
}

/**
 * Liste à puces, alignée à gauche dans un bloc lui-même centré (`inline-block`) : centrées comme le
 * reste du message, ces lignes devenaient illisibles dès qu'elles passaient à la ligne.
 */
export function detailVentilation(lignes: string[], titre?: string): string {
  if (lignes.length == 0) return '';
  const entete = titre
    ? `<div style="font-weight:600;color:#135253;padding-bottom:2px">${titre}</div>`
    : '';
  const items = lignes.map((ligne) => `<div style="padding-top:4px">• ${ligne}</div>`).join('');
  // Enveloppé dans un bloc : l'`inline-block` seul se plaçait à la suite du texte qui le précède,
  // jusqu'à couper une phrase en deux (« … sont » / liste / « complètes. »).
  return '<div><div style="text-align:left;display:inline-block;padding-top:10px">'
    + `${entete}${items}</div></div>`;
}

/**
 * Regroupe des comptes rendus par motif, du plus fréquent au moins fréquent : lister 200 lignes
 * « contrat #1234 : salarié non renseigné » n'aiderait personne. Commun aux actions de masse (échecs
 * DPAE, contrats à compléter ou en échec à l'envoi en signature).
 */
export function regrouperMotifs(elements: { motif: string }[]): { motif: string; nombre: number }[] {
  const comptes = new Map<string, number>();
  elements.forEach((element) => {
    comptes.set(element.motif, (comptes.get(element.motif) ?? 0) + 1);
  });
  return Array.from(comptes, ([motif, nombre]) => ({ motif, nombre }))
    .sort((a, b) => b.nombre - a.nombre);
}
